import {
  ThunkAction,
  Selector,
  AnyAction,
  EnhancedStore,
} from '@reduxjs/toolkit';
import { ThunkMiddlewareFor } from '@reduxjs/toolkit/dist/getDefaultMiddleware';
import { getDeveloperApi } from '@squareup/dex-data-shared-developer-api';
import { getConnectv2DocsApi } from '@squareup/dex-data-shared-doc-api';
import { shellViewStateStoreConfig } from '@squareup/dex-data-shared-main-data-slices';
import { combineReducers } from 'redux';

const {
  reducerPath: connectV2ReducerPath,
  reducer: connectV2Reducer,
  middleware: connectV2Middleware,
} = getConnectv2DocsApi();

const {
  reducerPath: developerApiReducerPath,
  reducer: developerApiReducer,
  middleware: developerApiMiddleware,
} = getDeveloperApi();

const reducers = {
  [shellViewStateStoreConfig.reducerPath]: shellViewStateStoreConfig.reducer,
  [connectV2ReducerPath]: connectV2Reducer,
  [developerApiReducerPath]: developerApiReducer,
};

const middlewares = [connectV2Middleware, developerApiMiddleware];

const combinedReducers = combineReducers(reducers);

type SharedStoreState = ReturnType<typeof combinedReducers>;
type Middlewares = [ThunkMiddlewareFor<SharedStoreState>];
type SharedStore = EnhancedStore<SharedStoreState, AnyAction, Middlewares>;
type SharedStoreDispatch = SharedStore['dispatch'];
type SharedStoreSelector<T> = Selector<SharedStoreState, T>;

type SharedStoreAction<T> = ThunkAction<
  T,
  SharedStoreState,
  undefined /* Extra args undefined for now*/,
  AnyAction
>;

type SharedStoreAsyncAction<T> = ThunkAction<
  Promise<T>,
  SharedStoreState,
  undefined /* Extra args undefined for now*/,
  AnyAction
>;

// TODO: Create a generic shell for all this that can be used for any app.

export {
  reducers,
  middlewares,
  type SharedStoreSelector,
  type SharedStore,
  type SharedStoreDispatch,
  type SharedStoreAction,
  type SharedStoreAsyncAction,
  type SharedStoreState,
};
